import React, { useEffect, useState } from 'react';

import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Tag } from "primereact/tag";
import useUserStore from "../../utils/storeApp";
import { Column } from "primereact/column";
import { gridObj } from "../../services/fakeDB/ReportObj";
import FailedReportView from '../shared/FailedReportView';
import $ from "jquery";

const ListUploadStatus = () => {
    const { isUserLogedIn, userRole, userToken } = useUserStore((state) => ({
        isUserLogedIn: state.isUserLogedIn,
        userRole: state.userRole,
        userToken: state.userToken,
    }));

    const [userObj, setUserObj] = useState([]);

    const [showGridFlag, SetShowGridFlag] = useState(
        userRole === "SESADMIN" ? false : true
    );
    const [showEmptyGridFlag, SetShowEmptyGridFlag] = useState(
        userRole === "SESADMIN" ? true : false
    );
    const navigate = useNavigate();
    const resultsClick = () => {
        navigate('/upload-results');
    }
    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        let tempObj = [];
        for (const row of gridObj) {
            if (row.UploadStatus === "Failed") {
                let status = (
                    <Tag severity={"danger"} onClick={resultsClick} >
                        Failed <i class="bi bi-exclamation-triangle-fill"></i>
                    </Tag>
                );
                row.UploadStatus = status;
            } else if (row.UploadStatus === "Completed") {
                let s = <Tag severity={"success"} onClick={resultsClick}>Completed</Tag>;
                row.UploadStatus = s;
            } else {
                let d = <Tag severity={"warning"}>In Progress</Tag>;
                row.UploadStatus = d;
            }
            tempObj.push(row);
        }
        setUserObj(tempObj);
    }, []);

    const getSeverity = (product) => {
        switch (product.UploadStatus) {
            case "Completed":
                return "success";
                break;
            case "In Progress":
                return "warning";
                break;
            case "Failed":
                return "danger";
                break;
            default:
                return null;
                break;
        }
    };
    return (
        <div className="ListUploadStatus">
            {/*{showEmptyGridFlag ?*/}
            {/*    (<section className="empty-grid">*/}
            {/*        There are currently no search results.*/}
            {/*    </section>*/}
            {/*    ) : null}*/}

            {/* {showGridFlag ? (*/}
            <div className="HeaderDownloadStatusTool">
                <header>
                    <div className="title-label">
                        <i
                            className="bi bi-box-arrow-in-up"
                            title="Uploads"
                        ></i>
                        <span className="spacer-margin2">List</span>
                    </div>
                    <div className="mid-header-bar spacer-inline">
                        <span className="SharedTools">
                            <button
                                className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                                title="Refresh Page"
                            >
                                <i
                                    className="bi bi-arrow-clockwise"
                                    alt="refresh page icon"
                                ></i>
                            </button>
                            <button
                                className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                                title="Print page"
                            >
                                <i className="bi bi-printer" alt="printer icon"></i>
                            </button>
                        </span>
                    </div>
                </header>
            </div>
            <section className="grid-layout">
                <div>
                    <DataTable
                        value={gridObj}
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 25, 50]}
                        tableStyle={{ minWidth: "50rem" }}
                        dataKey="Id"
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        selectionMode="single"
                        selection={selectedProduct}
                        onSelectionChange={(e) => setSelectedProduct(e.value)}
                        columnResizeMode="expand"
                        resizableColumns
                    >
                        <Column selectionMode="multiple" className="w-s"></Column>
                        <Column field="FileName" header="File Name" className="truncate" sortable></Column>
                        <Column field="DateCreated" header="Date Created" className="w-md8" sortable></Column>
                        <Column field="UploadType" header="Upload Type" className="w-md7" sortable></Column>
                        <Column field="StartedBy" header="Started By" sortable></Column>
                        <Column field="StartDate" header="Start Date" className="w-md8" sortable></Column>
                        <Column field="EndDate" header="End Date" className="w-md8" sortable></Column>
                        <Column field="UploadStatus" header="Status" className="w-md1" sortable></Column>
                        <Column field="Org" header="Organization" sortable></Column>
                        <Column field="Report" header="Report" sortable></Column>
                    </DataTable>
                </div>
                <div className="paging">
                    <div className="spacer-inline spacer-margin9">
                        <button className="btn btn-outline-secondary">Delete</button>
                    </div>
                </div>
            </section>
        </div>
    )
};


export default ListUploadStatus;
